import type { SpacingValue } from "@busbud/design-system-components/dist/types/tokens/spacing";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const CONTENT_PADDING_TOP: SpacingValue = 2;
export const CONTENT_PADDING_BOTTOM: SpacingValue = 3.5;
export const CONTENT_PADDING_X: SpacingValue = 3;

export const useStyles = createStyles(({ theme }) => {
  const { colors, spacing, styles } = theme.busbud;

  return {
    selectedSeats: {
      maxHeight: spacing(23), // Approximately equal to the size of three items with gaps
      padding: spacing(CONTENT_PADDING_TOP, CONTENT_PADDING_X),
      overflowY: "auto"
    },
    content: {
      padding: spacing(0, CONTENT_PADDING_X, CONTENT_PADDING_BOTTOM)
    },
    container: {
      paddingTop: spacing(2),
      borderTop: `${styles.borderWidth.sm} solid ${colors.border.primary.opaque}`
    }
  };
});
